module.exports = __webpack_public_path__ + "img/cloudImg4.03855aa9.png";